export default __webpack_public_path__ + "images/LeituraDisplay-Roman.font.8b32f5178157c0a2190da3c5018127a9.svg";